<template>
<div class="chapter">
<div class="inner_page">
<p class="chapnum" id="p01"><b>Part I</b></p>
<p class="chaptit" id="pt01">NORTHEAST CEMETERIES</p>
<p class="ch1"><b><i>NORTHEAST CUYAHOGA COUNTY CEMETERIES WITH ORIGINAL TOWNSHIPS, CIRCA MID-1800s</i></b></p>
<div class="image-break">
<p class="image"><img alt="Image" src="images/p11.jpg"/></p>
</div>
<p class="toc"><a href="#/chapter01">1. Ontario Street Burying Ground</a></p>
<p class="toc"><a href="#/chapter02">2. Erie Street Cemetery (Partial)</a></p>
<p class="toc"><a href="#/chapter03">3. Doan’s Corners Cemetery</a></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Old Glenville Cemetery</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Hungarian Congregational Church Cemetery</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Day Family Burying Ground</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Lewis Family Cemetery</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Saint Paul’s Protestant Episcopal Churchyard</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Demaline Cemetery</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Battles Cemetery</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Euclid Stop 8 Cemetery</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Peters Farm Cemetery</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Richmond Cemetery</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Crosier Cemetery</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. Spring Family Cemetery</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. Silas Johnson Family Cemetery</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. Bliss Cemetery</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">18. Kellogg Family Cemetery</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">19. Payne Family Cemetery</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">20. Johnson/DeVoe Family Cemetery</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6cdf8380